<template>
  <validation-provider :rules="rules" :name="`${tab}.${field}`" v-slot="{ valid, errors, changed }" :class="className" class="col">
    <b-button :id="`${tab}.${field}`" v-if="helpText" class="help-icon">?</b-button>
    <b-popover v-if="helpText" :target="`${tab}.${field}`" triggers="hover" placement="top">
      <template v-slot:title>Info</template>
      {{helpText}}
    </b-popover>
    <b-form-select
      :state="onValidateField(valid, errors, changed)"
      :value="getField"
      @input="updateField"
      :options="options"
    >
    </b-form-select>
    <b-form-invalid-feedback id="inputLiveFeedback">{{ errors[0] }}</b-form-invalid-feedback>
  </validation-provider>
</template>

<script>
  import { ValidationProvider } from 'vee-validate'
  import { mapState } from 'vuex'
  import { validateField } from '@/helpers/formHelper.js'

  export default {
    components: {
      ValidationProvider
    },
    props: {
      tab: {
        type: String,
        required: true
      },
      helpText: String,
      field: {
        type: String,
        required: true
      },
      options: {
        type: Array,
        required: true
      },
      placeholder: String,
      className: String,
      rules: String,
      appendText: String
    },
    computed: mapState({
      getField (state) {
        const { tab, field } = this
        return state.application.createApplication.formData[tab][field]
      }
    }),
    methods: {
      updateField (value) {
        const { tab, field } = this
        this.$store.commit('application/SET_FORMFIELD_VALUE', {
          tab,
          field,
          value
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      }
    }
  }
</script>
